<div class="um">
  <!-- Search, filter, sort, and the one action -->
  <div class="set-toolbar">
    <app-search-input label="Search users"
      class="set-toolbar__search"
      placeholder="Search by first name"
      (valueChange)="updateSearchTerm($event)"
    />

    <app-status-filter
      label="Status"
      [options]="filterOptions"
      [selectedValue]="filterCriteria"
      (selectionChange)="updateFilterCriteria($any($event))"
    />

    <app-sort-dropdown
      [groups]="sortGroups"
      [selectedValue]="sortCriteria"
      (selectionChange)="updateSortCriteria($any($event))"
    />

    <div class="set-toolbar__end" *hasPermission="{ category: 'USER_MANAGEMENT', permission: 'create-users' }">
      <button type="button" class="bk-btn bk-btn--primary" (click)="showAddUser = true">
        <span class="bk-sym" aria-hidden="true">person_add</span>
        Add user
      </button>
    </div>
  </div>

  <!-- Team at a glance. Later refreshes keep the table on screen; only the first load shows a skeleton. -->
  <p class="set-summary um__summary" aria-live="polite">
    @for (part of summary; track part.label; let first = $first) {
      @if (!first) {
        <span class="set-summary__sep" aria-hidden="true">·</span><span class="bk-sr-only">,</span>
      }
      <span [class.set-summary__bad]="part.tone === 'bad'"><strong>{{ part.value }}</strong> {{ part.label }}</span>
    } @empty {
      @if (tableLoading) {
        <span class="bk-skel um__summary-skel" aria-hidden="true"></span>
      }
    }
  </p>

  <app-users-table
    [users]="allUsers"
    [loading]="tableLoading"
    [params]="reactiveParams"
    [searchTerm]="searchTerm"
    [filtered]="isFiltered"
    [complete]="listIsComplete"
    [loadFailed]="usersFailed && !usersLoaded"
    (addUser)="showAddUser = true"
    (retry)="retryUsers()"
  ></app-users-table>

  <!-- add user modal -->
  <app-add-user-form
    [openModal]="showAddUser"
    (onClose)="showAddUser = false"
    (onSuccess)="onAddUserSuccess()"
  ></app-add-user-form>
</div>
